import { Home, ArrowLeft } from "lucide-react";
// @ts-ignore
import { tw } from "@careinfo/tailwind";

const PageNotFound = () => {
  return (
    <div
      className={tw`min-h-[calc(100vh-180px)] bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center `}
    >
      <div className={tw`max-w-2xl w-full text-center`}>
        {/* Animated 404 */}
        <div className={tw`relative mb-8  flex items-center justify-center `}>
          <h1
            className={tw`text-[180px] md:text-[240px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-700 leading-none animate-pulse`}
          >
            404
          </h1>
        </div>

        {/* Message */}
        <div className={tw`space-y-4 mb-10`}>
          <h2 className={tw`text-3xl md:text-4xl font-bold text-gray-800`}>
            Oops! Page Not Found
          </h2>
          <p className={tw`text-lg text-gray-600 max-w-md mx-auto`}>
            The page you're looking for seems to have wandered off into the
            digital wilderness.
          </p>
        </div>

        {/* Action Buttons */}
        <div
          className={tw`flex flex-col sm:flex-row gap-4 justify-center items-center`}
        >
          <button
            onClick={() => window.history.back()}
            className={tw`group focus:outline-none flex items-center gap-2 px-6 py-3 bg-white text-red-600 font-semibold rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border-2 border-red-600`}
          >
            <ArrowLeft
              className={tw`w-5 h-5 group-hover:-translate-x-1 transition-transform`}
            />
            Go Back
          </button>

          <button
            onClick={() => (window.location.href = "/")}
            className={tw`group flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-red-500 to-red-700
 text-white font-semibold rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1`}
          >
            <Home className={tw`w-5 h-5`} />
            Home Page
          </button>
        </div>

        {/* Decorative Elements */}
        <div className={tw`mt-16 flex justify-center gap-2`}>
          <div
            className={tw`w-3 h-3 bg-red-400 rounded-full animate-bounce`}
            style={{ animationDelay: "0ms" }}
          ></div>
          <div
            className={tw`w-3 h-3 bg-red-300 rounded-full animate-bounce`}
            style={{ animationDelay: "150ms" }}
          ></div>
          <div
            className={tw`w-3 h-3 bg-red-200 rounded-full animate-bounce`}
            style={{ animationDelay: "300ms" }}
          ></div>
        </div>

        {/* Additional Help Text */}
        <div className={tw`mt-12 text-sm text-gray-500`}>
          <p>Error Code: 404 | Page Not Found</p>
        </div>
      </div>

      {/* Background Decoration */}
      <div
        className={tw`fixed inset-0 -z-10 overflow-hidden pointer-events-none`}
      >
        <div
          className={tw`absolute top-20 left-10 w-72 h-72 bg-purple-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob`}
        ></div>
        <div
          className={tw`absolute top-40 right-10 w-72 h-72 bg-indigo-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000`}
        ></div>
        <div
          className={tw`absolute -bottom-20 left-1/2 w-72 h-72 bg-pink-300 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000`}
        ></div>
      </div>

      <style>{tw`
        @keyframes blob {
          0%, 100% {
            transform: translate(0px, 0px) scale(1);
          }
          33% {
            transform: translate(30px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-20px, 20px) scale(0.9);
          }
        }
        
        .animate-blob {
          animation: blob 7s infinite;
        }
        
        .animation-delay-2000 {
          animation-delay: 2s;
        }
        
        .animation-delay-4000 {
          animation-delay: 4s;
        }
      `}</style>
    </div>
  );
};

export default PageNotFound;
